export enum NativeApis {
  CONFIG = 'config',
  OPEN_URL = 'openUrl',
  zmGetUserInfo = 'zmGetUserInfo',
  zmGetClientInfo = 'zmGetClientInfo',
  zmGetLanguage = 'zmGetLanguage',
  zmGetNativeAppList = 'zmGetNativeAppList',
  zmOpenSettings = 'zmOpenSettings',
  zmGetAICOption = 'zmGetAICOption',
  zmNotifyStaticResourceUpdate = 'zmNotifyStaticResourceUpdate',
  zmGetAuthToken = 'zmGetAuthToken',
  zmGetChatInfo = 'zmGetChatInfo',
  composeCard = 'composeCard',
  closeModal = 'closeModal',

  getUserContext = 'getUserContext',
  zmRefreshApp = 'zmRefreshApp',
  zmOpenUrl = 'zmOpenUrl',
  zmGetMeetingQueryStatus = 'zmGetMeetingQueryStatus',
  zmSetMeetingQueryPrivilegeSetting = 'zmSetMeetingQueryPrivilegeSetting',
  zmGetMeetingQueryPrivilegeSetting = 'zmGetMeetingQueryPrivilegeSetting',
  zmGetUserInfoMeetingToken = 'zmGetUserInfoMeetingToken',
  zmGetMeetingSummaryStatus = 'zmGetMeetingSummaryStatus',
  zmGetPAAPLogServiceInfo = 'zmGetPAAPLogServiceInfo',
  zmGetMyMeetingSpeakingLanguage = 'zmGetMyMeetingSpeakingLanguage',
  zmMyMeetingQueryPrivileges = 'zmMyMeetingQueryPrivileges',
  zmCommonAicAction = 'zmCommonAicAction',
  zmGetMeetingUUID = 'zmGetMeetingUUID',
  zmSetCookie = 'zmSetCookie',
  zmDeleteCookie = 'zmDeleteCookie',
  zmGetStaticResourceConfiguration = 'zmGetStaticResourceConfiguration',
  zmCommonAicActionForPhone = 'zmCommonAicActionForPhone',
}

export enum NativeEvents {
  ON_ACTIVE_SPEAKER_CHANGE = 'onActiveSpeakerChange',
  ON_APP_POPOUT = 'onAppPopout',
  ON_CLOUD_RECORDING = 'onCloudRecording',
  ON_CONNECT = 'onConnect',
  ON_EXPAND_APP = 'onExpandApp',
  ON_MEETING = 'onMeeting',
  ON_MESSAGE = 'onMessage',
  ON_MY_ACTIVE_SPEAKER_CHANGE = 'onMyActiveSpeakerChange',
  ON_MY_MEDIA_CHANGE = 'onMyMediaChange',
  ON_MY_REACTION = 'onMyReaction',
  ON_MY_USER_CONTEXT_CHANGE = 'onMyUserContextChange',
  ON_PARTICIPANT_CHANGE = 'onParticipantChange',
  ON_REACTION = 'onReaction',
  ON_SEND_APP_INVITATION = 'sendAppInvitation',
  ON_SHARE_APP = 'shareApp',
  ON_MEETING_CONFIG_CHANGED = 'onMeetingConfigChanged',
  ON_BREAKOUT_ROOM_CHANGE = 'onBreakoutRoomChange',
  ON_INVITE_COLLABORATION = 'onInviteCollaboration',
  ON_COLLABORATE_CHANGE = 'onCollaborateChange',
  ON_GALLERY_PAGE_CHANGE = 'onGalleryPageChange',
  ON_RUNNING_CONTEXT_CHANGE = 'onRunningContextChange',
  ON_AUTHORIZED = 'onAuthorized',
  ON_CLOSE_APP_FOR_PARTICIPANTS = 'onCloseAppForParticipants',
  ON_RENDERED_APP_OPENED = 'onRenderedAppOpened',
  ON_FEEDBACK_REACTION_EVENT = 'onFeedbackReaction',
  ON_REMOVE_FEEDBACK_REACTION_EVENT = 'onRemoveFeedbackReaction',
  ON_INCOMING_PARTICIPANT_AUDIO_CHANGE = 'onIncomingParticipantAudioChange',
  ON_SHARE_SCREEN = 'onShareScreen',
  ON_SHARE_COMPUTER_AUDIO = 'onShareComputerAudio',
  ON_GALLERY_ORDER = 'onGalleryOrder',
  ON_EMOJI_REACTION = 'onEmojiReaction',
  ON_MEETING_VIEW_CHANGE = 'onMeetingViewChange',
  ON_PHONE_CALEE_ANSWERED = 'onPhoneCalleeAnswered',
  ON_PHONE_CALLER_ENDED = 'onPhoneCallerEnded',
  ON_PHONE_CALLEE_ENDED = 'onPhoneCalleeEnded',
  ON_PHONE_CALLEE_REJECTED = 'onPhoneCalleeRejected',
  ON_PHONE_CALLER_MEETING_INVITING = 'onPhoneCallerMeetingInviting',
  ON_PHONE_CALLEE_MEETING_INVITE = 'onPhoneCalleeMeetingInvite',
  ON_PHONE_CONTEXT = 'onPhoneContext',
  ON_ENGAGEMENT_CONTEXT_CHANGE = 'onEngagementContextChange',
  ON_ENGAGEMENT_STATUS_CHANGE = 'onEngagementStatusChange',
  ON_ENGAGEMENT_MEDIA_REDIRECT = 'onEngagementMediaRedirect',
  ON_MEETING_LANGUAGES_CHANGE = 'onMeetingLanguagesChange',
  ON_WAITING_ROOM_STATE_CHANGE = 'onWaitingRoomStateChange',
  ON_WAITING_ROOM_PARTICIPANT_LEAVE = 'onWaitingRoomParticipantLeave',
  ON_WAITING_ROOM_PARTICIPANT_JOIN = 'onWaitingRoomParticipantJoin',
  ON_PARTICIPANT_EMAIL = 'onParticipantEmail',
  ON_PHOTO = 'onPhoto',
  zmCommonAicActionForPhoneEvent = 'zmCommonAicActionForPhoneEvent',
  zmOnAppUpdated = 'zmOnAppUpdated',
}

export enum Timeouts {
  DEFAULT = 10000,
}
